const normalizeBaseUrl = (rawBaseUrl: string): string => {
  const withoutTrailingSlash = rawBaseUrl.endsWith('/')
    ? rawBaseUrl.slice(0, -1)
    : rawBaseUrl;

  return withoutTrailingSlash === '/' ? '' : withoutTrailingSlash;
};

export const getAppBasePath = (): string => {
  const rawBaseUrl = import.meta.env.BASE_URL ?? '/';
  return normalizeBaseUrl(rawBaseUrl);
};

const isAbsoluteUrl = (value: string): boolean => {
  // RFC 3986 scheme detection (e.g. https:, mailto:, tel:)
  return /^[a-zA-Z][a-zA-Z\d+\-.]*:/.test(value);
};

export const withAppBasePath = (pathname: string): string => {
  const basePath = getAppBasePath();
  if (!basePath) {
    return pathname;
  }

  if (!pathname) {
    return basePath;
  }

  if (isAbsoluteUrl(pathname)) {
    return pathname;
  }

  if (pathname === basePath || pathname.startsWith(`${basePath}/`)) {
    return pathname;
  }

  const right = pathname.startsWith('/') ? pathname : `/${pathname}`;
  return `${basePath}${right}`;
};
